import { render } from "./OrderManager.vue?vue&type=template&id=6aa82bea&scoped=true"
import script from "./OrderManager.vue?vue&type=script&lang=js"
export * from "./OrderManager.vue?vue&type=script&lang=js"

import "./OrderManager.vue?vue&type=style&index=0&id=6aa82bea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa82bea"]])

export default __exports__